/* eslint-disable @typescript-eslint/no-empty-function */
import { Core, Data, Labels, UI } from '@usercentrics/cmp-browser-sdk';
import { FunctionalComponent, createContext, h } from 'preact';
import { useContext, useState } from 'preact/hooks';

export type Maybe<T> = T | null | undefined;

type SettingsContextType = {
  core: Maybe<Core>;
  data: Maybe<Data>;
  labels: Maybe<Labels>;
  ui: Maybe<UI>;
  setSettingsCore: (value: Maybe<Core>) => void;
  setSettingsData: (value: Maybe<Data>) => void;
  setSettingsLabels: (value: Maybe<Labels>) => void;
  setSettingsUI: (value: Maybe<UI>) => void;
};

const initialValue = {
  core: null,
  data: null,
  labels: null,
  setSettingsCore: () => {},
  setSettingsData: () => {},
  setSettingsLabels: () => {},
  setSettingsUI: () => {},
  ui: null,
};

const SettingsContext = createContext<SettingsContextType>(initialValue);

export const SettingsContextProvider: FunctionalComponent = ({ children }) => {
  const [core, setSettingsCore] = useState<Maybe<Core>>(initialValue.core);
  const [data, setSettingsData] = useState<Maybe<Data>>(initialValue.data);
  const [labels, setSettingsLabels] = useState<Maybe<Labels>>(initialValue.labels);
  const [ui, setSettingsUI] = useState<Maybe<UI>>(initialValue.ui);

  return (
    <SettingsContext.Provider
      value={{
        core,
        data,
        labels,
        setSettingsCore,
        setSettingsData,
        setSettingsLabels,
        setSettingsUI,
        ui,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettingsContext = (): SettingsContextType => {
  return useContext(SettingsContext);
};
